import React from 'react';
import Box from '@mui/material/Box';
import FiberManualRecord from '@mui/icons-material/FiberManualRecord';

/**
 * An offer variation's state as a pill: green when active, red when paused. Tinted the way this
 * editor tints node states — the colour at 0.2 for the fill, the colour itself for the text, the
 * dot and the border (a colourless `border` takes currentColor) — so it holds in every preset and
 * in dark mode. The flow node's counts and the Offer tab's variations card both draw it, so the
 * two can't drift apart.
 */
const VariationStatusChip = ({ isActive, children, sx, ...rest }) => (
  <Box
    component='span'
    sx={[
      (theme) => {
        const main = (theme.vars ?? theme).palette[isActive ? 'success' : 'error'].main;
        return {
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.375,
          px: 0.75,
          py: 0.25,
          border: '1px solid',
          borderRadius: '999px',
          color: main,
          bgcolor: theme.alpha(main, 0.2),
          fontSize: '0.6875rem',
          fontWeight: 700,
          lineHeight: 1,
          whiteSpace: 'nowrap',
        };
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
    {...rest}
  >
    <FiberManualRecord sx={{ fontSize: '0.5rem' }} />
    {children}
  </Box>
);

export default VariationStatusChip;
